import { ErrorCode } from "tekkr-common/dist/model/api/error-codes";
import { ApiError } from "./service/tekkr-service";

export function isApiErrorWithCode(e: unknown, code: ErrorCode): e is ApiError {
    if (!(e instanceof ApiError)) {
        return false;
    }
    if (!e.body || typeof e.body !== "object" || !("code" in e.body)) {
        return false;
    }
    return e.body.code === code;
}

export function isApiError(e: unknown): e is ApiError {
    return e instanceof ApiError;
}
